<template>
  <!--STEG 1-->
  <CheckoutSelectNumberKeepNumberCode
    v-if="hasNotValidated"
    :cart-item-id="cartItemId"
    :bundle-id="bundleId"
    :show-transfer-owner-ssn="true"
    :parent-msisdn="parentMsisdn"
  >
    <template #visibleBeforeSubmit>
      <p>
        För att verifiera att numret är ditt skickar vi ett SMS till dig med en
        kod.
      </p>
    </template>
  </CheckoutSelectNumberKeepNumberCode>

  <!--STEG 2-->
  <CheckoutSelectNumberKeepNumberValidateCode
    v-if="codeHasBeenSentButNotValidated"
    :cart-item-id="cartItemId"
    :bundle-id="bundleId"
  />

  <!--STEG 3-->
  <AppNotification
    v-if="numberConfig.keepNumberCodeValidated"
    border-color="border-border-success"
  >
    <template #header>
      <nuxt-icon
        filled
        name="check-circle-green"
        class="text-[2.4rem]"
        aria-hidden="true"
      />
      <p class="heading-xxs" aria-hidden="true">
        {{ numberConfig.keepNumberInputValue }} är verifierat!
      </p>
    </template>
    <div class="flex flex-col gap-8" aria-live="polite" role="status">
      <span class="sr-only">Numret är verifierat!</span>
      <p>
        Ett ytterligare SMS med överlåtelseavtalet skickas efter beställning
        från Telia Sign. Nuvarande ägare signera det med BankID. Därefter
        flyttas numret.
      </p>
    </div>
    <button
      class="pt-8 body-link-md text-text-link underline halebop-focus hover:text-text-link-hover active:bg-surface-action-hover"
      @click="reset"
    >
      Ändra
    </button>
  </AppNotification>
  <!--STEG 3-->

  <div class="col-span-full">
    <button
      class="flex gap-8 p-9 text-text-link body-link-md hover:text-text-link-hover"
      type="button"
      @click="isDrawerOpen = true"
    >
      <nuxt-icon
        name="info"
        class="self-center text-[2.4rem]"
        aria-hidden="true"
      />
      <div class="text-left underline">
        Att tänka på om du väljer att flytta nummer åt dig eller en annan person
      </div>
    </button>
  </div>
  <CheckoutSelectNumberSelectionKeepNumberTransferOwnerDrawer
    v-model="isDrawerOpen"
  />
</template>

<script lang="ts" setup>
interface Props {
  cartItemId: number;
  bundleId: number;
  parentMsisdn?: string;
}
const props = withDefaults(defineProps<Props>(), { parentMsisdn: undefined });

const { codeHasBeenSentButNotValidated, hasNotValidated, numberConfig, reset } =
  useSelectNumberConfig({
    cartItemBundleId: props.bundleId,
    cartItemId: props.cartItemId,
  });

const isDrawerOpen = ref(false);
</script>

<style scoped lang="scss"></style>
